// One hand-bumped identifier per deploy of the labs bundle.
//
// WHY THIS EXISTS, and why analysis must split on it rather than on a timestamp:
// CloudFront serves the old bundle to already-warm clients for a while after a deploy, so
// "sessions after 14:06 UTC" is NOT the same set as "sessions running the new code". Any
// before/after comparison across a deploy split on time silently mixes the two. Every trace
// and every funnel event carries this string, so the split can be made exactly.
//
// BUMP THIS ON EVERY DEPLOY that changes labs behaviour or capture. Format: date + suffix.
export const LABS_BUILD = '2026-09-13-funnel2'
